import axios from '../config/axios'

class ApiService {
  private static baseUrl = process.env.REACT_APP_GATEWAY_BASE_URL

  static async get(url: string, params?: any, config?: any) {
    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🔄 [APISERVICE] GET - URL absoluta detectada:', {
        urlOriginal: url,
        baseUrl: baseUrl,
        urlFinal: finalUrl,
        isDuplicated: url.startsWith(baseUrl),
        params,
      });
      const response = await axios.get(finalUrl, { params, ...config })
      return response
    }

    console.log('🔄 [APISERVICE] GET - URL relativa:', {
      url: url,
      willBeConcatenatedWith: this.baseUrl,
      params,
    });
    const response = await axios.get(url, { params, ...config })
    return response
  }

  static async post(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] POST chamado:', {
      url,
      hasData: !!data,
      dataType: data?.constructor?.name || typeof data,
      isFormData: data instanceof FormData,
      formDataKeys: data instanceof FormData ? Array.from(data.keys()) : undefined,
      configKeys: config ? Object.keys(config) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] URL final:', finalUrl);
      const response = await axios.post(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta POST recebida:', {
        status: response.status,
        statusText: response.statusText,
        hasData: !!response.data,
        dataType: typeof response.data
      });
      return response
    }

    console.log('🎯 [APISERVICE] URL final:', url);
    const response = await axios.post(url, data, config)

    console.log('✅ [APISERVICE] Resposta POST recebida:', {
      status: response.status,
      statusText: response.statusText,
      hasData: !!response.data,
      dataType: typeof response.data
    });

    return response
  }

  static async put(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] PUT chamado:', {
      url,
      hasData: !!data,
      dataType: data?.constructor?.name || typeof data,
      isFormData: data instanceof FormData,
      formDataKeys: data instanceof FormData ? Array.from(data.keys()) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] URL final:', finalUrl);
      const response = await axios.put(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta PUT recebida:', {
        status: response.status,
        statusText: response.statusText,
        hasData: !!response.data
      });
      return response
    }

    console.log('🎯 [APISERVICE] URL final:', url);
    const response = await axios.put(url, data, config)

    console.log('✅ [APISERVICE] Resposta PUT recebida:', {
      status: response.status,
      statusText: response.statusText,
      hasData: !!response.data
    });

    return response
  }

  static async delete(url: string, config?: any) {
    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      const response = await axios.delete(finalUrl, config)
      return response
    }

    const response = await axios.delete(url, config)
    return response
  }

  static async patch(url: string, data?: any, config?: any) {
    console.log('🚀 [APISERVICE] PATCH chamado:', {
      url,
      hasData: !!data,
      dataKeys: data ? Object.keys(data) : undefined
    });

    const isAbsoluteUrl = url.startsWith('http')

    if (isAbsoluteUrl) {
      const baseUrl = this.baseUrl || ''
      const finalUrl = baseUrl && url.startsWith(baseUrl) ? url.substring(baseUrl.length) : url
      console.log('🎯 [APISERVICE] PATCH - URL final:', finalUrl);
      const response = await axios.patch(finalUrl, data, config)
      console.log('✅ [APISERVICE] Resposta PATCH recebida:', {
        status: response.status,
        statusText: response.statusText
      });
      return response
    }

    console.log('🎯 [APISERVICE] PATCH - URL final:', url);
    const response = await axios.patch(url, data, config)
    console.log('✅ [APISERVICE] Resposta PATCH recebida:', {
      status: response.status,
      statusText: response.statusText
    });
    return response
  }

  static stock = {
    findAll: (params?: any) => this.get('/backend/stock/findAll', params),
    create: (data: any) => this.post('/backend/stock', data),
    update: (id: number, data: any) => this.put(`/backend/stock/${id}`, data),
    delete: (id: number) => this.delete(`/backend/stock/${id}`),
    updateCode: (id: number, data: any) => this.patch(`/backend/stock/${id}/code`, data),
    getTotalStock: () => this.get('/backend/stock/getTotalStock')
  }

  static auth = {
    login: (credentials: any) => this.post('/backend/login', credentials),
    googleAuth: (token: any) => this.post('/backend/googleAuthenticate', token),
    magicLogin: (hash: string) => this.get('/backend/magic-login', { h: hash }),
    register: (userData: any) => this.post('/backend/user', userData),
    resetPassword: (email: string) => this.post('/backend/reset-password', { email }),
    resetPasswordConfirm: (data: any) => this.post('/backend/reset-password/reset', data)
  }

  static certificates = {
    findById: (id: number) => this.get(`/certificates/certificate/${id}`),
    findIdByServiceId: (serviceId: number) =>
      this.get(`/certificates/certificate/by-service/${serviceId}`),
    getUtils: (id: number) => this.get(`/certificates/certificate/utils/view/${id}`),
    getTypes: () => this.get('/certificates/certificate/utils/types'),
    getMaterials: (params?: any) => this.get('/certificates/certificate/utils/materials', params),
    getHeatNumbers: (params?: any) => this.get('/certificates/certificate/utils/heat-numbers', params),
    getParams: (params?: any) => this.get('/certificates/param', params)
  }

  static companies = {
    findAll: (params?: any) => this.get('/companies/companies', params),
    findById: (id: number) => this.get(`/companies/companies/${id}`),
    create: (data: any) => this.post('/companies/companies', data),
    update: (id: number, data: any) => this.put(`/companies/companies/${id}`, data),
    delete: (id: number) => this.delete(`/companies/companies/${id}`),
    getTypes: () => this.get('/companies/companies/types'),
    getStates: () => this.get('/companies/companies/states'),
    getCepInfo: (cep: string) => this.post('/companies/address/cep', { cep }),
    getInscricaoEstadual: (cnpj: string) => this.get(`/companies/companies/inscricao-estadual/${cnpj}`),
    getCnpjDetails: (cnpj: string) => this.get(`/companies/companies/cnpj/${cnpj}`)
  }

  static productionFlow = {
    getFunctions: () => this.get('/production-flow/functions'),
    createFunction: (data: any) => this.post('/production-flow/functions', data),
    getMachines: (params?: any) => this.get('/production-flow/pcp/machines', params),
    createMachine: (data: any) => this.post('/production-flow/machine', data),
    updateMachine: (id: number, data: any) => this.patch(`/production-flow/machine/${id}`, data),
    updateService: (id: number, data: any) => this.patch(`/production-flow/pcp/service/${id}`, data),
    searchServices: (params?: any) => this.get('/production-flow/pcp/services/paginated', params),
    listServices: (params?: { search?: string; quantity?: number }) =>
      this.get('/production-flow/service', params),
    getServiceById: (id: number) => this.get(`/production-flow/service/${id}`),
    getService: (id: number) => this.get(`/production-flow/service/${id}`),
    createService: (data: any) => this.post('/production-flow/service', data),
    previewSubOps: (data: { serviceId: number; scriptId: number }) =>
      this.post('/production-flow/service/subop-tree-preview', data),
    generateSubOps: (serviceId: number, data: { scriptId: number; productId?: number }) =>
      this.post(`/production-flow/service/${serviceId}/generate-subops`, data),
    getServicesOfOp: (opId: number | string) => this.get(`/production-flow/pcp/services-of-op/${opId}`),
    getRawMaterials: (params?: any) => this.get('/production-flow/service/utils/raw-materials', params),
    getRawMaterialById: (id: number) => this.get(`/production-flow/service/utils/raw-materials/${id}`),
    getUtilResources: (params?: any) => this.get('/production-flow/service/utils/resources', params),
    getUtilStages: (params?: any) => this.get('/production-flow/service/utils/stages', params),
  }

  static profiles = {
    findAll: (params?: any) => this.get('/backend/profile/findAll', params),
    findById: (id: number) => this.get(`/backend/profile/find/${id}`),
    create: (data: any) => this.post('/backend/profile', data),
    patch: (id: number, data: { name?: string; permissions?: string[] }) =>
      this.patch(`/backend/profile/${id}`, data),
    delete: (id: number) => this.delete(`/backend/profile/${id}`),
    getTotal: (params?: any) => this.get('/backend/profile/count', params)
  }

  static user = {
    findById: (id: number) => this.get(`/backend/user/${id}`),
    me: () => this.get('/backend/user/me'),
    generateLink: (data: any) => this.post('/backend/user/link-generator', data),
    updateStatus: (id: number, data: { status: string }) =>
      this.patch(`/backend/user/updatestatus/${id}`, data),
  }

  static code = {
    delete: (code: string) => this.delete(`/backend/code/${code}`),
  }

  static skill = {
    updateUserSkills: (userId: number, skillIds: number[]) =>
      this.patch(`/backend/user/${userId}/skills`, { skillIds }),
  }

  static movements = {
    find: (params?: any) => this.get('/backend/stock-movement/find', params),
    getTotal: (params?: any) => this.get('/backend/stock-movement/count', params),
    findByStockId: (stockId: number) => this.get(`/backend/stock-movement/stock/${stockId}`),
    findByResourceId: (resourceId: number) => this.get(`/backend/stock-movement/resource/${resourceId}`),
  }

  static steelOrders = {
    createTenant: (data: any) => this.post('/backend/tenant', data),
    findOrders: (params?: any) => this.get('/steel-orders/order', params),
    findOrderItemById: (id: number) => this.get(`/steel-orders/order-item/${id}`),
    getPaymentConditions: (params?: any) => this.get('/steel-orders/select-in-order/payment-conditions', params),
    createPaymentCondition: (data: { name: string }) => this.post('/steel-orders/select-in-order/payment-conditions', data),
    getPaymentMethods: () => this.get('/steel-orders/select-in-order/payment-methods'),
    getRepresentatives: (params?: any) => this.get('/steel-orders/select-in-order/representatives', params),
    createRepresentative: (data: { name: string }) => this.post('/steel-orders/select-in-order/representatives', data),
    getOrderSituations: (params?: any) => this.get('/steel-orders/select-in-order/order-situations', params),
    createOrderSituation: (data: { name: string }) => this.post('/steel-orders/select-in-order/order-situations', data),
    getGeneralClasses: (params?: any) => this.get('/steel-orders/select-in-order/general-classes', params),
    createGeneralClass: (data: { name: string }) => this.post('/steel-orders/select-in-order/general-classes', data),
    getOrderTypes: (params?: any) => this.get('/steel-orders/select-in-order/order-types', params),
    createOrderType: (data: { name: string }) => this.post('/steel-orders/select-in-order/order-types', data),
    deleteOrderType: (id: number) => this.delete(`/steel-orders/select-in-order/order-types/${id}`),
    deleteRepresentative: (id: number) => this.delete(`/steel-orders/select-in-order/representatives/${id}`),
    deleteOrderSituation: (id: number) => this.delete(`/steel-orders/select-in-order/order-situations/${id}`),
    deleteGeneralClass: (id: number) => this.delete(`/steel-orders/select-in-order/general-classes/${id}`),
  }

  static ocr = {
    process: (data: any) => this.post('https://ordeno-ocr-260311756054.southamerica-east1.run.app/ocr', data)
  }

  static addStockModal = {
    uploadExcel: (data: any, headers: any) => this.post('/backend/import-from-excel/upload', data, { headers }),
    createStock: (endpoint: string, data: any) => this.post(endpoint, data),
    getStockData: (endpoint: string) => this.get(endpoint)
  }

  static reverseMovement = {
    reverse: (ploomesId: number, data: any) => this.patch(`/backend/reverse-stock-movement/${ploomesId}`, data)
  }

  static admin = {
    inviteNewAdmin: (email: string) => this.post('/backend/new-admin/email', { email })
  }

  static resources = {
    findById: (id: number) => this.get(`/resources/resource/${id}`),
    create: (data: any) => this.post('/resources/resource', data),
    update: (id: number, data: any) => this.patch(`/resources/resource/${id}`, data),
    delete: (id: number) => this.delete(`/resources/resource/${id}`),
    getCategories: (params?: any) => this.get('/resources/resource/util/categories', params),
    createCategory: (data: any) => this.post('/resources/resource/util/categories', data),
    deleteCategory: (id: number) => this.delete(`/resources/resource/util/categories/${id}`),
    getTypes: (params?: any) => this.get('/resources/resource/util/types', params),
    createType: (data: any) => this.post('/resources/resource/util/types', data),
    deleteType: (id: number) => this.delete(`/resources/resource/util/types/${id}`),
    getColors: (params?: any) => this.get('/resources/resource/util/colors', params),
    createColor: (data: any) => this.post('/resources/resource/util/colors', data),
    deleteColor: (id: number) => this.delete(`/resources/resource/util/colors/${id}`)
  }

  static services = {
    getMachines: (params?: any) => this.get('/services/service-stage/util/machine', params),
    getServices: (params?: any) => this.get('/production-flow/pcp/services', params),
    updateService: (id: number, data: any) => this.patch(`/production-flow/service/${id}`, data),
    findById: (id: number) => this.get(`/services/service-stage/${id}`),
    create: (data: any) => this.post('/services/service-stage', data),
    update: (id: number, data: any) => this.patch(`/services/service-stage/${id}`, data),
    getCategories: (params?: any) => this.get('/services/service-stage/util/categories', params),
    createCategory: (data: any) => this.post('/services/service-stage/util/categories', data),
    deleteCategory: (id: number) => this.delete(`/services/service-stage/util/categories/${id}`),
    getTypes: (params?: any) => this.get('/services/service-stage/util/types', params),
    createType: (data: any) => this.post('/services/service-stage/util/types', data),
    deleteType: (id: number) => this.delete(`/services/service-stage/util/types/${id}`),
    getAreas: (params?: any) => this.get('/services/service-stage/util/areas', params),
    createArea: (data: any) => this.post('/services/service-stage/util/areas', data),
    deleteArea: (id: number) => this.delete(`/services/service-stage/util/areas/${id}`),
    getSectors: (params?: any) => this.get('/services/service-stage/util/sectors', params),
    createSector: (data: any) => this.post('/services/service-stage/util/sectors', data),
    deleteSector: (id: number) => this.delete(`/services/service-stage/util/sectors/${id}`),
    createMachine: (data: any) => this.post('/services/service-stage/util/machine', data),
    deleteMachine: (id: number) => this.delete(`/services/service-stage/util/machine/${id}`),
    getUnits: () => this.get('/services/service-stage/util/units'),
  }

  static pcp = {
    findById: (id: number) => this.get(`/production-flow/pcp/${id}`),
    addService: (data: any) => this.post('/production-flow/pcp/service', data),
    confirm: (id: number, data: any) => this.patch(`/production-flow/pcp/${id}/status`, data),
    generatePDF: (id: number, params?: any) => this.get(`/production-flow/pcp/${id}/export`, params),
    getHistory: (id: number) => this.get(`/production-flow/pcp/${id}/history`),
    selectMaterials: (data: any) => this.post('/production-flow/pcp/select-materials', data),
    selectServices: (data: any) => this.post('/production-flow/pcp/select-services', data),
    split: (id: number, data: any) => this.post(`/production-flow/pcp/${id}/split`, data),
    discountItems: (opId: number, data: any) => this.post(`/production-flow/pcp/discount/${opId}`, data),
  }

  static structure = {
    getColumns: (id: number) => this.get(`/certificates/column/${id}`)
  }

  static status = {
    getCurrentStatus: (params?: any) => this.get('/backend/stock/current-status', params)
  }

  static parameters = {
    getFormats: (params?: any) => this.get('/certificates/param/formats', params)
  }

  static stockLookup = {
    getMaterials: (params?: any) => this.get('/backend/material/list', params),
    getMaterialsForResource: (params?: any) => this.get('/backend/material/list/resource', params),
    getMaterialsForStock: (params?: any) => this.get('/backend/material/list/stock', params),
    createMaterial: (data: { name: string; type?: 'STOCK' | 'RESOURCE' }) => this.post('/backend/material', data),
    deleteMaterial: (id: number) => this.delete(`/backend/material/${id}`),
    getFormats: (params?: any) => this.get('/backend/format/list', params),
    createFormat: (data: any) => this.post('/backend/format', data),
    deleteFormat: (id: number) => this.delete(`/backend/format/${id}`),
    getFabrications: (params?: any) => this.get('/backend/fabrication/list', params),
    createFabrication: (data: any) => this.post('/backend/fabrication', data),
    deleteFabrication: (id: number) => this.delete(`/backend/fabrication/${id}`),
    getNcms: (params?: any) => this.get('/backend/ncm/list', params),
    createNcm: (data: any) => this.post('/backend/ncm', data),
    deleteNcm: (id: number) => this.delete(`/backend/ncm/${id}`),
    getShelfs: (params?: any) => this.get('/backend/shelf/list', params),
    createShelf: (data: any) => this.post('/backend/shelf', data),
    deleteShelf: (id: number) => this.delete(`/backend/shelf/${id}`),
    getStockLocations: (params?: any) => this.get('/backend/stockLocation/list', params),
    createStockLocation: (data: any) => this.post('/backend/stockLocation', data),
    deleteStockLocation: (id: number) => this.delete(`/backend/stockLocation/${id}`),
    getStockStreets: (params?: any) => this.get('/backend/stockStreet/list', params),
    createStockStreet: (data: any) => this.post('/backend/stockStreet', data),
    deleteStockStreet: (id: number) => this.delete(`/backend/stockStreet/${id}`),
    getColors: (params?: any) => this.get('/backend/color/list', params),
    createColor: (data: any) => this.post('/backend/color', data),
    deleteColor: (id: number) => this.delete(`/backend/color/${id}`),
    getFamilies: (params?: any) => this.get('/backend/family/list', params),
    createFamily: (data: any) => this.post('/backend/family', data),
    deleteFamily: (id: number) => this.delete(`/backend/family/${id}`),
    getOriginCountries: (params?: any) => this.get('/backend/originCountry/list', params),
    createOriginCountry: (data: any) => this.post('/backend/originCountry', data),
    deleteOriginCountry: (id: number) => this.delete(`/backend/originCountry/${id}`),
    getFinishings: (params?: any) => this.get('/backend/finishing/list', params),
    createFinishing: (data: any) => this.post('/backend/finishing', data),
    deleteFinishing: (id: number) => this.delete(`/backend/finishing/${id}`),
    getHeatNumbers: (params?: any) => this.get('/backend/heat-number/list', params),
    createHeatNumber: (data: any) => this.post('/backend/heat-number', data),
    deleteHeatNumber: (id: number) => this.delete(`/backend/heat-number/${id}`),
  }

  static infiniteSelect = {
    get: (url: string, config: any) => this.get(url, config?.params, config),
    post: (url: string, payload: any, config: any) => this.post(url, payload, config),
    delete: (url: string, config: any) => this.delete(url, config)
  }

  static occurrences = {
    findAll: (params?: any) => this.get('/production-flow/occurrence', params),
    findById: (id: number) => this.get(`/production-flow/occurrence/${id}`),
    create: (data: any) => this.post('/production-flow/occurrence', data),
    update: (id: number, data: any) => this.patch(`/production-flow/occurrence/${id}`, data),
    delete: (id: number) => this.delete(`/production-flow/occurrence/${id}`),
    uploadFiles: (id: number, formData: FormData) =>
      this.post(`/production-flow/occurrence/${id}/upload-files`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }),
    downloadFile: (occurrenceId: number, fileId: number) =>
      this.get(`/production-flow/occurrence/${occurrenceId}/files/${fileId}/download`)
  }

  static stages = {
    findAll: (params?: any) => this.get('/production-flow/stages', params)
  }

  static productFinal = {
    findAll: (params?: any) => this.get('/product-final/product', params),
    findById: (id: number) => this.get(`/product-final/product/${id}`),
    getScript: (id: number) => this.get(`/product-final/script/${id}`),
  }

  static buyOrder = {
    findAll: () => this.get('/production-flow/buy-order'),
    create: (data: any) => this.post('/production-flow/buy-order', data),
    getByProduction: (productionId: number) =>
      this.get(`/production-flow/buy-order/by-production/${productionId}`),
    getById: (id: number) => this.get(`/production-flow/buy-order/${id}`),
    update: (id: number, data: any) =>
      this.patch(`/production-flow/buy-order/${id}`, data),
    delete: (id: number) => this.delete(`/production-flow/buy-order/${id}`),
    consumeFromStock: (id: number) =>
      this.post(`/production-flow/buy-order/${id}/consume-from-stock`),
    markPurchased: (id: number) =>
      this.post(`/production-flow/buy-order/${id}/mark-purchased`),
    bulkMarkPurchased: (ids: number[]) =>
      this.post('/production-flow/buy-order/bulk/mark-purchased', { ids }),
    bulkConsumeFromStock: (ids: number[]) =>
      this.post('/production-flow/buy-order/bulk/consume-from-stock', { ids }),
  }

  static fashion = {
    findAllCollections: (params?: any) => this.get('/backend-fashion-orders/fashion-product/collections', params),
    findCollectionById: (id: number) => this.get(`/backend-fashion-orders/fashion-product/collections/${id}`),
    createCollection: (data: any) => this.post('/backend-fashion-orders/fashion-product/collections', data),
    updateCollection: (id: number, data: any) => this.put(`/backend-fashion-orders/fashion-product/collections/${id}`, data),
    deleteCollection: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/collections/${id}`),
    findAllPantones: (params?: any) => this.get('/backend-fashion-orders/fashion-product/pantones', params),
    findAllGrades: () => this.get('/backend-fashion-orders/fashion-product/grades'),
    findAllGroups: () => this.get('/backend-fashion-orders/fashion-product/groups'),
    createGroup: (data: { name: string }) => this.post('/backend-fashion-orders/fashion-product/groups', data),
    deleteGroup: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/groups/${id}`),
    findAllResourceCategories: () => this.get('/backend-fashion-orders/fashion-product/resource-categories'),
    findAllResources: () => this.get('/backend-fashion-orders/fashion-product/resources'),
    getCollectionFamilies: (id: number) => this.get(`/backend-fashion-orders/fashion-product/collections/${id}/families`),
    createCollectionColor: (collectionId: number, data: any) => this.post(`/backend-fashion-orders/fashion-product/collections/${collectionId}/colors`, data),
    deleteCollectionColor: (collectionId: number, colorId: number) => this.delete(`/backend-fashion-orders/fashion-product/collections/${collectionId}/colors/${colorId}`),
    createColor: (data: any) => this.post('/backend-fashion-orders/fashion-product/colors', data),
    createGrade: (data: { name: string; typeName: string }) => this.post('/backend-fashion-orders/fashion-product/grades', data),
    updateGrade: (id: number, data: { name?: string; typeName?: string }) => this.put(`/backend-fashion-orders/fashion-product/grades/${id}`, data),
    deleteGrade: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/grades/${id}`),
    findAllEpisodes: (params?: any) => this.get('/backend-fashion-orders/fashion-product/episodes', params),
    createEpisode: (collectionId: number, data: { name: string }) => this.post(`/backend-fashion-orders/fashion-product/collections/${collectionId}/episodes`, data),
    deleteEpisode: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/episodes/${id}`),
    createFamily: (data: { name: string; collectionId: number }) => this.post('/backend-fashion-orders/fashion-product/families', data),
    deleteFamily: (id: number) => this.delete(`/backend-fashion-orders/fashion-product/families/${id}`)
  }

  static fiscal = {
    getInvoices: (params?: { take?: number; skip?: number; search?: string; filters?: string }) => this.get('/fiscal/invoice', params),
    getInvoice: (id: number) => this.get(`/fiscal/invoice/${id}`),
    getEligibleNfeItems: (orderId: number) => this.get('/fiscal/invoice/nfe/items', { orderId, t: Date.now() }),
    createNfe: (data: any) => this.post('/fiscal/invoice/nfe', data),
    updateInvoice: (id: number, data: any) => this.patch(`/fiscal/invoice/${id}`, data),
    removeInvoiceItem: (invoiceId: number, itemId: number, quantidade: number) =>
      this.patch(`/fiscal/invoice/${invoiceId}/items/${itemId}`, { quantidadeARemover: quantidade }),
    addInvoiceItems: (id: number, items: any[]) => this.patch(`/fiscal/invoice/${id}/items`, { items }),
    deleteInvoice: (id: number) => this.delete(`/fiscal/invoice/${id}`),
    emitir: (id: number) => this.post(`/fiscal/invoice/${id}/emitir`),
    cancelar: (id: number) => this.post(`/fiscal/invoice/${id}/cancelar`),
    nfeStatus: (id: number) => this.get(`/fiscal/invoice/${id}/nfe-status`),
    lookup: (params: { ncmId?: number; nbsId?: number; cfopId: number; stateId: number; companyEmissorId?: number }) =>
      this.get('/fiscal/tax-config/lookup', params),
    getCfops: (params?: { ncmId?: number; stateId?: number; companyEmissorId?: number }) => this.get('/fiscal/tax-config/cfops', params),
    getNcms: (params?: { cfopId?: number; stateId?: number; companyEmissorId?: number }) => this.get('/fiscal/tax-config/ncms', params),
    getTaxCodes: () => this.get('/fiscal/tax-config/tax-codes'),
    getClassTrib: (params?: { cstIbsCbsId?: number }) => this.get('/fiscal/tax-config/class-trib', params),
    getTaxConfigs: () => this.get('/fiscal/tax-config'),
    getTaxConfig: (id: number) => this.get(`/fiscal/tax-config/${id}`),
    createTaxConfig: (data: any) => this.post('/fiscal/tax-config/product', data),
    updateTaxConfig: (id: number, data: any) => this.patch(`/fiscal/tax-config/${id}`, data),
    deleteTaxConfig: (id: number) => this.delete(`/fiscal/tax-config/${id}`),
    getCompanyGateways: () => this.get('/fiscal/company-gateway'),
  }
}

export default ApiService
